<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <v-card
      outlined
      class="pa-4"
      elevation="0"
      @click="startUpload"
    >
      <div class="d-flex align-center">
        <template v-if="fileStore">
          {{ $t('SelectedUploadItems', {items: displayFileStore.length}) }}
          <v-spacer />
          <v-icon>mdi-check</v-icon>
        </template>
        <template v-else>
          <template v-if="haveFile">
            {{ $t('HaveFileUpload') }}
          </template>
          <template v-else>
            {{ $t('SelectTheItemsForUpload') }}
          </template>
          <v-spacer />
          <v-btn
            v-if="haveFile"
            outlined
            color="primary"
            elevation="0"
          >
            {{ $t('DownloadAll') }}
          </v-btn>
        </template>
      </div>
      <div
        class="mt-4"
        v-if="displayFileStore"
      >
        <div
          class="text-body-2 text--secondary"
          v-for="f in displayFileStore"
          :key="f.name"
        >
          <v-icon
            size="16"
          >
            mdi-paperclip
          </v-icon>
          {{ f.name }}
        </div>
      </div>
    </v-card>
    <v-file-input
      ref="file"
      v-model="fileStore"
      :rules="rules"
      accpet="image/*"
      counter
      class="mt-2"
      dense
      :multiple="multiple"
      outlined
      prepend-icon=""
      prepend-inner-icon="mdi-file"
      show-size
      style="height: 0;opacity: 0"
    />
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    value: {},
    currentUrl: {},
    multiple: {},
    rules: {}
  },
  watch: {
    fileStore (val) {
      this.$emit('input', val)
    }
  },
  data: function () {
    return {
      fileStore: null
    }
  },
  computed: {
    displayFileStore: function () {
      return [this.fileStore ?? []].flat()
    },
    haveFile: function () {
      return this.currentUrl
    }
  },
  methods: {
    startUpload () {
      this.$refs.file.$refs.input.click()
    }
  }
}
</script>

<style scoped>

</style>
